import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useBtnDisabled } from "shared/hooks";
import { PrimaryBtn } from "components/common/button";
import {
  PlaceInfoTable,
  FacilityInfoTable,
  BurialPlotsTable,
  ImgInfoTable,
} from "components/burial/add";
import { OneBtnModal } from "components/common/modal";
import { postPark } from "service/api/burial";
import type { IBurialAdd } from "service/interface/burial";
import responseCodeConstant from "service/constant/responseCodeConstant";
import routerConstant from "service/constant/routerConstant";

export function BurialAddPage() {
  const navigate = useNavigate();
  const [isSuccessModalVisible, setIsSuccessModalVisible] =
    useState<boolean>(false);
  const [data, setData] = useState<IBurialAdd>({
    ...({} as IBurialAdd),
    isPublic: true,
    BurialPlots: [],
    SearchOptions: [],
    imageIds: [],
    isHandicapped: false,
    isParking: false,
    isRestaurant: false,
    isSnack: false,
    isWaitingRoom: false,
  });
  const isBtnDisable = useBtnDisabled(data, [
    "name",
    "operatingHours",
    "telephone",
    "address",
  ]);

  const handleAddBtn = async () => {
    const saveRes = await postPark(data);
    if (saveRes.status === responseCodeConstant.SUCCESS.ok) {
      setIsSuccessModalVisible(true);
    } else {
      window.alert("에러입니다.");
    }
  };

  const handleSuccessBtn = () => {
    navigate(routerConstant.BURIAL.list);
  };

  return (
    <>
      <OneBtnModal
        isVisible={isSuccessModalVisible}
        setIsVisible={setIsSuccessModalVisible}
        title="등록 완료"
        subTitle="성공적으로 등록되었습니다."
        btnLabel="확인"
        btnClick={handleSuccessBtn}
      />
      <div className="h-full min-h-[100vh] w-[calc(100%-273px)] bg-[#fdfdfd]">
        <div className="mx-auto w-[1167px] p-[78px_80px_72px_64px]">
          <p className="m-0 mb-[8px] text-[16px] font-semibold leading-[20px] text-gray-4 opacity-[0.5]">
            메모리올 관리자 화면
          </p>
          <div className="flex items-center justify-between">
            <p className="m-0 text-[32px] font-medium leading-[40px] text-black">
              장지 정보
            </p>
            <PrimaryBtn
              label="저장하기"
              isDisabled={
                isBtnDisable ||
                typeof data.religion !== "number" ||
                // data.SearchOptions?.length === 0 ||
                data.BurialPlots?.length === 0
              }
              onClick={handleAddBtn}
            />
          </div>
          <div className="mt-[32px] rounded-[12px] bg-white p-[48px_40px_64px_48px] shadow-[0px_0px_8px_rgba(0,0,0,0.1)]">
            <PlaceInfoTable data={data} setData={setData} />
            <FacilityInfoTable data={data} setData={setData} />
            <BurialPlotsTable data={data} setData={setData} />
            <ImgInfoTable data={data} setData={setData} />
          </div>
        </div>
      </div>
    </>
  );
}
